import { render, staticRenderFns } from "./PricelistAssignToEventsModal.vue?vue&type=template&id=52dbae49&"
import script from "./PricelistAssignToEventsModal.vue?vue&type=script&lang=js&"
export * from "./PricelistAssignToEventsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports